export default __webpack_public_path__ + "static/smarter-working-live-logo-sm-68b197f84b8e9b20ea5e3195206eeb6e.png";